// src/firebase/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyA82cBsUe6gFHlbWFcMdx98gByn8aAqYHo",
  authDomain: "toolip-d7c18.firebaseapp.com",
  projectId: "toolip-d7c18",
  storageBucket: "toolip-d7c18.firebasestorage.app",
  messagingSenderId: "598141766974",
  appId: "1:598141766974:web:ffcd2595cd5c45f44d306f",
  measurementId: "G-8PQHFNPK6X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Legacy compatibility: export a null analytics placeholder.
// (Analytics is initialized in src/analytics/analytics.js after consent.)
export const analytics = null;

/**
 * Adds an email to the 'emails' collection.
 * Uses the email as the document ID to ensure uniqueness.
 * @param {string} email - The email to add.
 * @returns {Promise<void>}
 */
const addEmail = async (email) => {
  const sanitizedEmail = email.toLowerCase();
  const emailDocRef = doc(db, 'emails', sanitizedEmail);

  // Check if the email already exists
  const docSnap = await getDoc(emailDocRef);
  if (docSnap.exists()) {
    throw new Error('This email is already subscribed.');
  }

  // Add the email
  await setDoc(emailDocRef, {
    email: sanitizedEmail,
    subscribedAt: new Date(),
  });
};

export { app, auth, db, addEmail, functions };